import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Resolve image URL — handle absolute URLs and backend-relative paths
export function resolveImage(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/uploads/")) return `${BACKEND_URL}/api${url}`;
  return `${BACKEND_URL}${url}`;
}

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Silently handle expected 401 on /auth/me (user not logged in is a normal state)
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || "";
    const status = err?.response?.status;
    if (status === 401 && url.includes("/auth/me")) {
      // Return a synthetic resolved response to avoid triggering webpack-dev-server error overlay
      return Promise.resolve({ data: null, status: 401, suppressedAuth: true, headers: {}, config: err.config });
    }
    return Promise.reject(err);
  },
);

export default api;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Įvyko klaida";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}
